import React from 'react';
import PropTypes from 'prop-types';
import './styles/sign.scss';
import { Fragment } from 'react';
import ReportProblemIcon from '@material-ui/icons/ReportProblem';
import * as deviceStates from './constants/deviceStates';

const SignDisplayOverlay = ({
    loading, errorState, signType
}) => {
    // console.log(errorState)
    if(errorState === deviceStates.OK) {
        return <Fragment/>
    }

    if(errorState === deviceStates.MALFUNCTION || errorState === deviceStates.COMMUNICATION_FAILURE || errorState === deviceStates.NOT_CONNECTED_NO_DATA) {
        return (<div className={signType==="HYBRID_64_X_64"?"errorImage hybrid":"errorImage"}>
            <ReportProblemIcon className="icon error"/>
        </div>)
    }

    if(errorState === deviceStates.PARTLY_MALFUNCTION) {
        return (<div className={signType==="HYBRID_64_X_64"?"errorImage hybrid":"errorImage"}>
            <ReportProblemIcon className={signType==="HYBRID_64_X_64"?"icon warn hybrid":"icon warn"}/>
        </div>)
    }

    if(!loading && errorState === deviceStates.UNKNOWN) {
        return (<div className={signType==="HYBRID_64_X_64"?"errorImage hybrid":"errorImage"}>
           <div className={signType==="HYBRID_64_X_64"?"icon error hybrid":"icon error"} style={{display:'flex', justifyContent:'center', alignItems:'center'}}>?</div>
        </div>)
    }

    return <Fragment/>
};

SignDisplayOverlay.propTypes = {
  loading: PropTypes.bool,
  errorState: PropTypes.number
};

export default SignDisplayOverlay;